import styled from 'styled-components';

export const HomeWrapper = styled.div`
  flex-grow: 1;
`;
